import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVoiceLow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"voice-low, wave"} maskId="square-filled-radius-0-stroke-1-IconVoiceLow"><path d="M8 18H7V6H8V18Z" fill="currentColor"/><path d="M17 16H16V8H17V16Z" fill="currentColor"/><path d="M12.5 14H11.5V10H12.5V14Z" fill="currentColor"/><path d="M4 13.5H3V10.5H4V13.5Z" fill="currentColor"/><path d="M21 13.5H20V10.5H21V13.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconVoiceLow;
